import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import useFetchForm from "modules/forms/hooks/usefetchForm";
import HostedFormContainer from "modules/forms/hosted/HostedFormContainer";
import BootPublicForm from "modules/forms/hosted/public/BootPublicForm";
import { HelmetProvider } from "react-helmet-async";
import { FormContext } from '../context/FormContext';
import BootPrivateForm from "modules/forms/hosted/private/BootPrivateForm";
import FormIsNotActive from "modules/forms/hosted/FormIsNotActive";
import FullScreenLoader from "components/FullScreenLoader";

export default function HostedForm() {
    const { formUuid } = useParams<{ formUuid: string }>();
    const navigate = useNavigate();
    const { form } = useFetchForm(formUuid);
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (!form) {
            return;
        }

        if (form.type == "private") {
            const tokenFromSearchParams = searchParams.get("token");
            let token;

            if (tokenFromSearchParams) {
                sessionStorage.setItem("token", tokenFromSearchParams);
                token = tokenFromSearchParams;
            } else {
                token = sessionStorage.getItem("token");
            }

            if (token) {
                if (location.pathname == `/forms/${form.uuid}/private/authenticated/custom-success`) {
                    // Do not navigate somewhere else.
                } else {
                    navigate(`/forms/${form.uuid}/private/authenticated/custom`);
                }
            } else {
                if (location.pathname == `/forms/${form.uuid}/private/authenticate-success`) {
                    // Do not navigate somewhere else.
                } else {
                    navigate(`/forms/${form.uuid}/private/authenticate`);
                }
            }
        } else {
            if (location.pathname == `/forms/${form.uuid}/public/custom-success`) {
                // Do not navigate somewhere else.
            } else {
                navigate(`/forms/${form.uuid}/public/custom`);
            }
        }
    }, [form, location.pathname]);

    if (!form) {
        return <FullScreenLoader/>;
    }

    return (
        <HelmetProvider>
            <FormContext.Provider value={{
                form: form,
                onSubmit: console.log,
                onError: console.error,
            }}
            >
                {/*<WithRecaptcha>*/}
                <HostedFormContainer>
                    {form.is_active ? (
                        <Routes>
                            <Route path={"/public/*"} element={<BootPublicForm/>}/>
                            <Route path={"/private/*"} element={<BootPrivateForm/>}/>
                        </Routes>
                    ) : (
                        <FormIsNotActive form={form}/>
                    )}
                </HostedFormContainer>
                {/*</WithRecaptcha>*/}
            </FormContext.Provider>
        </HelmetProvider>
    );
}